module.exports = __webpack_public_path__ + "img/vk.ca4211c4.png";